import { z } from "zod";

/**
 * The values of an open enum: the ones this build names, plus any other string. Service enums are open by
 * contract (a service may send a value before the client that reads it deploys), so code that branches on
 * one keeps literal types for the values it handles and a default for the rest.
 */
export type OpenEnum<T extends string> = T | (string & Record<never, never>);

/**
 * A zod schema for an open enum value: any string is accepted at runtime, and the inferred type keeps the
 * literals in `known`. The known list is a type, not a filter: it never rejects, drops or reports a value.
 */
export function openEnum<const T extends readonly [string, ...string[]]>(known: T) {
  // `known` carries the literal types; the schema accepts whatever the service sends.
  void known;
  return z.string() as unknown as z.ZodType<OpenEnum<T[number]>, z.ZodTypeDef, string>;
}
